<script>
import axios from "axios";
import Swal from "sweetalert2";
import Pagination from "@/router/layouts/table-pagination.vue";

export default {
  components: {
    Pagination,
  },

  props: {
    show: Boolean,
    idWorkOrder: {
      type: [String, Number],
      default: null,
    },
  },

  data() {
    return {
      BACKEND_URL_VERSION: process.env.VUE_APP_BACKEND_URL_VERSION,
      isLoading: false,
      isSubmitting: false,
      listPesertaTidakBisaDiApprove: [],
      filter: {
        page: 1,
        per_page: 10,
      },
      pagination: {
        lastPage: "",
        currentPage: "",
        total: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "",
        to: "",
        links: "",
      },
    };
  },

  computed: {
    modalShow: {
      get() {
        return this.show;
      },
      set(val) {
        if (!val) this.$emit("close");
      },
    },
  },

  watch: {
    modalShow(val) {
      if (val) this.getListPeserta();
      else this.resetState();
    },
  },

  methods: {
    resetState() {
      this.listPesertaTidakBisaDiApprove = [];
      this.filter.page = 1;
      this.pagination = {
        lastPage: "",
        currentPage: "",
        total: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "",
        to: "",
        links: "",
      };
    },

    configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
      this.pagination.links = data.links;
    },

    toPage(url) {
      let link = new URLSearchParams(url);
      this.filter.page = link.get("page");
      this.getListPeserta();
    },

    getListPeserta() {
      this.isLoading = true;

      var config = {
        method: "post",
        url: this.BACKEND_URL_VERSION + "work-order/detail/list-peserta",
        params: {
          id_work_order: this.idWorkOrder,
          peserta_sudah_mengajukan: false,
          page: this.filter.page,
          per_page: this.filter.per_page,
        },
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
      };

      axios(config)
        .then((response) => {
          let response_data_fix = response.data?.data ?? {};
          this.listPesertaTidakBisaDiApprove = response_data_fix.data ?? [];
          this.configPagination(response_data_fix);
        })
        .catch((err) => {
          Swal.fire({
            icon: "error",
            title: "Gagal",
            text:
              err.response?.data?.data ||
              err.response?.data?.meta?.message ||
              "Gagal memuat daftar peserta.",
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    approvePeserta() {
      if (this.isSubmitting) return;

      Swal.fire({
        icon: "warning",
        title: "Approve Peserta",
        text: "Semua peserta yang memenuhi syarat akan di approve otomatis. Apakah anda yakin?",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: "Ya",
        denyButtonText: "Tidak",
      }).then((result) => {
        if (!result.isConfirmed) return;

        this.isSubmitting = true;

        axios({
          method: "post",
          url: this.BACKEND_URL_VERSION + "work-order/detail/approve-peserta",
          data: { id_work_order: this.idWorkOrder },
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + localStorage.access_token,
          },
        })
          .then((response) => {
            Swal.fire({
              icon: "success",
              title: "Berhasil",
              text:
                response.data?.meta?.message ||
                "Peserta berhasil di approve.",
              timer: 1500,
              timerProgressBar: true,
              showConfirmButton: false,
            });
            this.$emit("finish");
            this.$emit("close");
          })
          .catch((err) => {
            Swal.fire({
              icon: "error",
              title: "Gagal",
              text:
                err.response?.data?.data ||
                err.response?.data?.meta?.message ||
                "Gagal melakukan approve peserta.",
            });
          })
          .finally(() => {
            this.isSubmitting = false;
          });
      });
    },
  },
};
</script>

<template>
  <b-modal
    v-model="modalShow"
    title="Approve Peserta"
    size="lg"
    hide-footer
    :no-close-on-backdrop="isSubmitting"
    :no-close-on-esc="isSubmitting"
    :hide-header-close="isSubmitting"
  >
    <p class="fw-bold mb-3">
      Semua peserta akan di approve otomatis, sehingga menyelesaikan proses
      approve atasan dan hcbp.
    </p>

    <div v-if="isLoading" class="text-center py-4">
      <i class="fa fa-spinner fa-spin fa-2x"></i>
      <div class="mt-3">Memuat daftar peserta...</div>
    </div>

    <template v-else-if="listPesertaTidakBisaDiApprove.length > 0">
      <div class="alert alert-warning fw-bold mb-3">
        <i class="fa fa-info-circle text-warning me-1"></i>
        Ada beberapa peserta yang tidak bisa di approve otomatis, dikarenakan
        belum mengajukan pemilihan kompetensi atau jumlah kompetensi yang
        dipilih dengan target kompetensinya masih kurang.
      </div>

      <div class="table-responsive">
        <table class="table table-sm table-bordered table-hover table-striped align-middle mb-0">
          <thead class="bg-warning text-dark fw-bold text-center">
            <tr>
              <th style="width: 50px">No</th>
              <th>Kode</th>
              <th>Nama Pegawai</th>
              <th>Nama Profesi</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in listPesertaTidakBisaDiApprove"
              :key="item.id_work_order_detail || index"
            >
              <td class="text-center">{{ index + 1 }}</td>
              <td class="text-center">{{ item.pegawai_internal?.u_nip || "-" }}</td>
              <td>{{ item.pegawai_internal?.nama || "-" }}</td>
              <td>{{ item.mprofesi?.nama_profesi || "-" }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <pagination :pagination="pagination" @to-page="toPage"></pagination>
    </template>

    <div v-else class="alert alert-info fw-bold mb-0">
      <i class="fa fa-info-circle text-primary me-1"></i>
      Semua peserta memenuhi syarat untuk di approve otomatis.
    </div>

    <div class="text-end mt-3">
      <b-button variant="secondary" class="me-2 fw-bold" :disabled="isSubmitting" @click="$emit('close')">
        <i class="fa fa-times me-1"></i>
        Tutup
      </b-button>
      <b-button variant="primary" class="fw-bold" :disabled="isLoading || isSubmitting" @click="approvePeserta">
        <span v-if="isSubmitting">
          <i class="fa fa-spinner fa-spin me-1"></i> Memproses...
        </span>
        <span v-else>
          <i class="fa fa-check me-1"></i> Approve
        </span>
      </b-button>
    </div>
  </b-modal>
</template>
